import { useMutation } from '@tanstack/react-query'
import { useEffect, useRef } from 'react'

import { authAPI } from '@/api/new-api'
import { toastFactory } from '@/factories'
import { downloadHref, getApiErrorMessage } from '@/utils'

import { GetGuestsRequest } from './get-guests'

export interface ExportGuestsRequest
  extends Omit<GetGuestsRequest, 'buildingId' | 'skip' | 'limit'> {
  buildingId: number
  fileName: string
}

export const exportGuests = async (params: Omit<ExportGuestsRequest, 'fileName'>) => {
  const response = await authAPI.get<Blob>('/client-guest/export-csv', {
    params,
    responseType: 'blob',
  })
  return response.data
}

export const useExportGuests = () => {
  const objectUrlRef = useRef<string | null>(null)

  const mutation = useMutation({
    mutationFn: async ({ fileName, ...params }: ExportGuestsRequest) => {
      const blob = await exportGuests(params)
      if (objectUrlRef.current) URL.revokeObjectURL(objectUrlRef.current)
      objectUrlRef.current = URL.createObjectURL(blob)
      downloadHref(objectUrlRef.current, fileName)
      return objectUrlRef.current
    },
    onError: (error) => {
      toastFactory.error(getApiErrorMessage(error))
    },
  })

  useEffect(() => {
    return () => {
      if (objectUrlRef.current) URL.revokeObjectURL(objectUrlRef.current)
    }
  }, [])

  return mutation
}
